import ScoringWizardStepOne, { validator } from './ScoringWizardStepOne'

export { validator }
export default ScoringWizardStepOne
